/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { resourcesList } from "../funcs/resourcesList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListResourcesResult } from "../models/components/listresourcesresult.js";
import {
  ListResourcesRequest,
  ListResourcesSecurity,
} from "../models/operations/listresources.js";
import { unwrapAsync } from "../types/fp.js";

export class Resources extends ClientSDK {
  /**
   * listResources resources
   *
   * @remarks
   * List all resources for a project
   */
  async list(
    request?: ListResourcesRequest | undefined,
    security?: ListResourcesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListResourcesResult> {
    return unwrapAsync(resourcesList(
      this,
      request,
      security,
      options,
    ));
  }
}
